import axios from 'axios';

var axios_request = axios.create({
    baseURL: process.env.VUE_APP_ADMIN_ENDPOINT_BASE_URL,
    headers: {'Content-Type': 'application/json'}
});

const getConfig = headerparams => {
    return { headers: { 'authorization': '', ...headerparams }};
};

/////////////////////////////////////


export const updateOrdersDatabase = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'update_order_database');
    // apiFormData.set('f', 'update_special');
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data', ...headerparams})
    )
}

export const updateAccountReceivables = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'update_account_receivables');
    // apiFormData.set('f', 'update_special');
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data', ...headerparams})
    )
}

export const updateCustomerDatabase = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'update_customer_database');
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data', ...headerparams})
    )
}

export const getCustomerDetail = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_orders_data');
    apiFormData.set('filter_type', 'ALL');
    apiFormData.set('sorting_key', 'total_qty_ordered');
    apiFormData.set('sorting_asc_desc', 'DESC');
    apiFormData.set('customer_id_only', params.customer_id);
    apiFormData.set('include_details', 1);

    if(params.is_noah === 1) {
        apiFormData.set('is_noah', params.is_noah);
    }

    if(params.combined_shop) {
        apiFormData.set('combined_shop', params.combined_shop);
    }

    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getRoadDetails = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_road_nearest_list');
    apiFormData.set('license_number', params.license_number);
    apiFormData.set('id', params.id);
    apiFormData.set('max_distance', params.max_distance);

    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getSleepData = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_sleep_data');
    apiFormData.set('type', params.type);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getVapeData = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_theplant_data');
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}


export const getRoadData = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_road_data');
    apiFormData.set('type', params.type);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getCAMapData = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_ca_map_data');
    apiFormData.set('type', params.type);
    apiFormData.set('center_lon', params.center_lon);
    apiFormData.set('center_lat', params.center_lat);
    apiFormData.set('radius', params.radius);

    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const markShopVisited = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'mark_map_shop_visited');
    apiFormData.set('customer_id', params.customer_id);
    apiFormData.set('type', 'map_button_click');

    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getCompare60120List = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_customers_60120_days');
    apiFormData.set('min_amount', params.min_amount);
    apiFormData.set('percentage_drop', params.percentage_drop);
    apiFormData.set('asc_desc', params.asc_desc);
    apiFormData.set('plus_minus', params.plus_minus);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const updateCompare60120List = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'update_customers_60120_days');
    apiFormData.set('min_amount', params.min_amount);
    apiFormData.set('percentage_drop', params.percentage_drop);
    apiFormData.set('asc_desc', params.asc_desc);
    apiFormData.set('plus_minus', params.plus_minus);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getReportMainData = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_report_main_data');
    apiFormData.set('custom_month', params.custom_month);
    apiFormData.set('custom_year', params.custom_year);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getAccountReceivablesList = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_account_receivable_list');
    apiFormData.set('customer_id',  params.customer_id);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getAccountReceivablesNotesLog = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'log_customer_note_ar');
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getOrdersListLastOrders = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_orders_data');
    apiFormData.set('filter_type', 'MORETHANONE');
    apiFormData.set('sorting_key', 'days_since_last_order');
    apiFormData.set('sorting_asc_desc', 'ASC');
    apiFormData.set('customer_id_only', 0);
    apiFormData.set('include_details', 0);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getWebAccountsList = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_web_account_list');
    apiFormData.set('sort_type', params.sort_type);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const storeWebShopContact = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'store_web_shop_contact');
    apiFormData.set('customer_id', params.customer_id);
    apiFormData.set('shop_number', params.shop_number);
    apiFormData.set('contact_phone', params.contact_phone);
    apiFormData.set('contact_person', params.contact_person);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getOrdersListLastOrdersNoah = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_orders_data');
    apiFormData.set('filter_type', 'MORETHANONE');
    apiFormData.set('sorting_key', 'days_since_last_order');
    apiFormData.set('sorting_asc_desc', 'ASC');
    apiFormData.set('customer_id_only', 0);
    apiFormData.set('include_details', 0);
    apiFormData.set('is_noah', 1);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getOrdersListByProductSKU = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_orders_data');
    apiFormData.set('filter_type', 'PRODUCTSKU');
    apiFormData.set('sorting_key', 'days_since_last_order');
    apiFormData.set('sorting_asc_desc', 'ASC');
    apiFormData.set('customer_id_only', 0);
    apiFormData.set('include_details', 0);
    apiFormData.set('is_noah', 0);
    apiFormData.set('product_sku', params.product_sku);

    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}


export const getOrdersListOneOrder = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_orders_data');
    apiFormData.set('filter_type', 'ONLYONE');
    apiFormData.set('sorting_key', 'days_since_last_order');
    apiFormData.set('sorting_asc_desc', 'DESC');
    apiFormData.set('customer_id_only', 0);
    apiFormData.set('include_details', 0);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const addNewCustomerNote = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'add_new_customer_note');
    apiFormData.set('customer_id', params.customer_id);
    apiFormData.set('note', params.note);

    if(params.is_noah === 1) {
        apiFormData.set('is_noah', params.is_noah);
    }

    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}
export const addNewCustomerNoteAR = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'add_new_customer_note_ar');
    apiFormData.set('customer_id', params.customer_id);
    apiFormData.set('note', params.note);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const setCustomerField = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'update_customer_field');
    apiFormData.set('customerid', params.customer_id);
    apiFormData.set('fieldname', params.fieldname);
    apiFormData.set('value', params.value);

    if(params.is_noah === 1) {
        apiFormData.set('is_noah', params.is_noah);
    }

    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const setRoadField = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'update_road_field');
    apiFormData.set('record_id', params.record_id);
    apiFormData.set('fieldname', params.fieldname);
    apiFormData.set('value', params.value);
    apiFormData.set('max_distance', params.max_distance);
    apiFormData.set('license_number', params.license_number);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const setCustomerFieldAR = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'update_customer_field_ar');
    apiFormData.set('customerid', params.customer_id);
    apiFormData.set('fieldname', params.fieldname);
    apiFormData.set('value', params.value);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}


export const setButtonValue = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'update_button_value');
    apiFormData.set('customerid', params.customer_id);
    apiFormData.set('function_button', params.function_button);
    apiFormData.set('value', params.value);

    if(params.is_noah === 1) {
        apiFormData.set('is_noah', params.is_noah);
    }

    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const setOrderFlagValue = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'update_order_flag_value');
    apiFormData.set('customerid', params.customer_id);
    apiFormData.set('fieldname', params.fieldname);
    apiFormData.set('order_id', params.order_id);
    apiFormData.set('value', params.value);

    if(params.is_noah === 1) {
        apiFormData.set('is_noah', params.is_noah);
    }

    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getSampleOnlyList = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'sample_only_list');
    apiFormData.set('details_only', 0);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getHiddenList = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_orders_data');
    apiFormData.set('filter_type', 'ALL');
    apiFormData.set('sorting_key', 'days_since_last_order');
    apiFormData.set('sorting_asc_desc', 'DESC');
    apiFormData.set('customer_id_only', 0);
    apiFormData.set('include_details', 0);
    apiFormData.set('show_hidden_list', 1);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getCallLog = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_call_log');
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getLfbGraphData = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_lfb_graph_data');
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}









